// material
import { Box, Card, Typography } from "@material-ui/core";
import { alpha, styled } from "@material-ui/core/styles";
import { Assignment } from "@material-ui/icons";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
	boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
	borderRadius: "10px",
	textAlign: "center",
	// padding: theme.spacing(5, 0),
	color: theme.palette.info.darker,
	backgroundColor: theme.palette.info.lighter,
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
	margin: "auto",
	display: "flex",
	borderRadius: "50%",
	alignItems: "center",
	width: theme.spacing(6),
	height: theme.spacing(6),
	justifyContent: "center",
	marginBottom: theme.spacing(3),
	color: theme.palette.info.dark,
	backgroundImage: `linear-gradient(135deg, ${alpha(
		theme.palette.info.dark,
		0
	)} 0%, ${alpha(theme.palette.info.dark, 0.24)} 100%)`,
}));

// ----------------------------------------------------------------------

// const TOTAL = 714000;

export default function Total({ issue }) {
	return (
		<RootStyle>
			<IconWrapperStyle>
				<Assignment width={24} height={24} />
			</IconWrapperStyle>
			<Typography variant="h3">{fShortenNumber(issue.total)}</Typography>
			<Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
				Total
			</Typography>
			<Box
				style={{
					display: "flex",
					height: "10vh",
					backgroundColor: "#87CEEB",
					fontSize: "20px",
				}}
			>
				<span
					style={{
						display: "flex",
						justifyContent: "space-around",
						width: "100%",
						alignItems: "center",
						fontWeight: "bold",
					}}
				>
					<p>
						{issue?.late_data?.bulan} : {issue?.late_data?.jumlah}
					</p>
					<p>
						{issue?.current_data?.bulan} : {issue?.current_data?.jumlah}
					</p>
				</span>
			</Box>
		</RootStyle>
	);
}
